webpackJsonp([221374088121123],{

/***/ "./node_modules/prismjs/themes/prism-okaidia.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/react-redux/lib/components/Provider.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__("./node_modules/react-redux/lib/utils/PropTypes.js");
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),

/***/ "./node_modules/react-redux/lib/components/connectAdvanced.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__("./node_modules/hoist-non-react-statics/index.js");
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("./node_modules/react/index.js");
	
	var _Subscription = __webpack_require__("./node_modules/react-redux/lib/utils/Subscription.js");
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__("./node_modules/react-redux/lib/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/connect.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__("./node_modules/react-redux/lib/components/connectAdvanced.js");
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__("./node_modules/react-redux/lib/utils/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__("./node_modules/react-redux/lib/connect/mapDispatchToProps.js");
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__("./node_modules/react-redux/lib/connect/mapStateToProps.js");
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__("./node_modules/react-redux/lib/connect/mergeProps.js");
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__("./node_modules/react-redux/lib/connect/selectorFactory.js");
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/mapDispatchToProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _wrapMapToProps = __webpack_require__("./node_modules/react-redux/lib/connect/wrapMapToProps.js");
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/mapStateToProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__("./node_modules/react-redux/lib/connect/wrapMapToProps.js");
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/mergeProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__("./node_modules/react-redux/lib/utils/verifyPlainObject.js");
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/selectorFactory.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__("./node_modules/react-redux/lib/connect/verifySubselectors.js");
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/verifySubselectors.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/wrapMapToProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__("./node_modules/react-redux/lib/utils/verifyPlainObject.js");
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__("./node_modules/react-redux/lib/components/Provider.js");
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__("./node_modules/react-redux/lib/components/connectAdvanced.js");
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__("./node_modules/react-redux/lib/connect/connect.js");
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/Subscription.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/shallowEqual.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/verifyPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/warning.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ "./node_modules/redux-devtools-extension/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var compose = __webpack_require__("./node_modules/redux/lib/index.js").compose;
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);
	
	exports.devToolsEnhancer = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION__ :
	    function() { return function(noop) { return noop; } }
	);


/***/ }),

/***/ "./node_modules/redux/lib/applyMiddleware.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__("./node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),

/***/ "./node_modules/redux/lib/bindActionCreators.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),

/***/ "./node_modules/redux/lib/combineReducers.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__("./node_modules/redux/lib/createStore.js");
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__("./node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),

/***/ "./node_modules/redux/lib/compose.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),

/***/ "./node_modules/redux/lib/createStore.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__("./node_modules/symbol-observable/index.js");
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),

/***/ "./node_modules/redux/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__("./node_modules/redux/lib/createStore.js");
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__("./node_modules/redux/lib/combineReducers.js");
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__("./node_modules/redux/lib/bindActionCreators.js");
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__("./node_modules/redux/lib/applyMiddleware.js");
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__("./node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__("./node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),

/***/ "./node_modules/redux/lib/utils/warning.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ "./node_modules/symbol-observable/index.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/symbol-observable/lib/index.js");


/***/ }),

/***/ "./node_modules/symbol-observable/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__("./node_modules/symbol-observable/lib/ponyfill.js");
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/symbol-observable/lib/ponyfill.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),

/***/ "./src/components/HeaderMenu/HeaderMenu.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/index.js");
	var react_redux_2 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var store_2 = __webpack_require__("./src/store.ts");
	var semantic_ui_react_7 = __webpack_require__("./node_modules/semantic-ui-react/dist/commonjs/index.js");
	var logo = __webpack_require__("./src/images/icon_75.png");
	var gatsby_utils_2 = __webpack_require__("./src/gatsby-utils.ts");
	exports.HeaderMenu = function (_ref) {
	    var items = _ref.items,
	        pathname = _ref.pathname,
	        Link = _ref.Link,
	        inverted = _ref.inverted,
	        dispatch = _ref.dispatch;
	    return React.createElement(semantic_ui_react_7.Container, null, React.createElement(semantic_ui_react_7.Menu, { size: "large", pointing: true, secondary: true, inverted: inverted }, React.createElement(semantic_ui_react_7.Menu.Item, { as: "a", className: "mobile only", icon: "sidebar", onClick: function onClick() {
	            return dispatch(store_2.toggleSidebar());
	        } }), React.createElement(semantic_ui_react_7.Menu.Item, { as: Link, to: "/", name: "Gradus Reason Home", className: "mobile hidden" }, React.createElement("img", { src: logo, alt: "Gradus Reason" })), items.map(function (item) {
	        var unprefixedPathname = gatsby_utils_2.withoutPrefix(pathname);
	        var active = item.exact ? unprefixedPathname === item.path : unprefixedPathname.startsWith(item.path);
	        return React.createElement(semantic_ui_react_7.Menu.Item, { as: Link, className: "mobile hidden", name: item.name, to: item.path, key: item.path, active: active });
	    }), React.createElement(semantic_ui_react_7.Menu.Item, { href: "https://github.com/codekiln/gradus-reason", target: "_blank" }, React.createElement(semantic_ui_react_7.Icon, { name: "github", alt: "Gradus Reason" }))));
	};
	exports.default = react_redux_2.connect()(exports.HeaderMenu);

/***/ }),

/***/ "./src/components/SidebarMenu/SidebarMenu.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/index.js");
	var react_redux_3 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var semantic_ui_react_13 = __webpack_require__("./node_modules/semantic-ui-react/dist/commonjs/index.js");
	exports.SidebarMenu = function (_ref) {
	    var items = _ref.items,
	        pathname = _ref.pathname,
	        Link = _ref.Link,
	        visible = _ref.visible;
	    var isActive = function isActive(item) {
	        return item.exact ? pathname === item.path : pathname.startsWith(item.path);
	    };
	    var activeItem = items.find(function (item) {
	        return isActive(item);
	    }) || {};
	    return React.createElement(semantic_ui_react_13.Sidebar, { as: semantic_ui_react_13.Menu, animation: "slide along", width: "thin", visible: visible, icon: "labeled", vertical: true, inverted: activeItem.inverted }, items.map(function (item) {
	        var active = isActive(item);
	        return React.createElement(semantic_ui_react_13.Menu.Item, { as: Link, to: item.path, active: active, key: item.path }, React.createElement(semantic_ui_react_13.Icon, { name: item.icon }), item.name);
	    }));
	};
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        visible: state.isSidebarVisible
	    };
	};
	exports.default = react_redux_3.connect(mapStateToProps)(exports.SidebarMenu);

/***/ }),

/***/ "./src/css/responsive.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/css/semantic.min.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/css/styles.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/gatsby-utils.ts":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var gatsby_link_4 = __webpack_require__("./node_modules/gatsby-link/index.js");
	function withPrefix(path) {
	    return gatsby_link_4.withPrefix(path);
	}
	exports.withPrefix = withPrefix;
	function withoutPrefix(path) {
	    if (true) {
	        return path.replace((""), "");
	    }
	    return path;
	}
	exports.withoutPrefix = withoutPrefix;
	function getPrefixedSrcSet(srcSet) {
	    return srcSet.split(",\n").map(function (imgSrc) {
	        return withPrefix(imgSrc);
	    }).join(",\n");
	}
	exports.getPrefixedSrcSet = getPrefixedSrcSet;

/***/ }),

/***/ "./src/images/gradus_1.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gradus_1.cfec1af6.jpg";

/***/ }),

/***/ "./src/images/gradus_2.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gradus_2.19fba16f.jpg";

/***/ }),

/***/ "./src/images/gradus_3.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gradus_3.91d33156.jpg";

/***/ }),

/***/ "./src/images/icon_75.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/images/js_logo.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MzAgNjMwIj4KPHJlY3Qgd2lkdGg9IjYzMCIgaGVpZ2h0PSI2MzAiIGZpbGw9IiNmN2RmMWUiLz4KPHBhdGggZD0ibTQyMy4yIDQ5Mi4xOWMxMi42OSAyMC43MiAyOS4yIDM1Ljk1IDU4LjQgMzUuOTUgMjQuNTMgMCA0MC4yLTEyLjI2IDQwLjItMjkuMiAwLTIwLjMtMTYuMS0yNy40OS00My4xLTM5LjNsLTE0LjgtNi4zNWMtNDIuNzItMTguMi03MS4xLTQxLTcxLjEtODkuMiAwLTQ0LjQgMzMuODMtNzguMiA4Ni43LTc4LjIgMzcuNjQgMCA2NC43IDEzLjEgODQuMiA0Ny40bC00Ni4xIDI5LjZjLTEwLjE1LTE4LjItMjEuMS0yNS4zNy0zOC4xLTI1LjM3LTE3LjM0IDAtMjguMzMgMTEtMjguMzMgMjUuMzcgMCAxNy43NiAxMSAyNC45NSAzNi40IDM1Ljk1bDE0LjggNi4zNGM1MC4zIDIxLjU3IDc4LjcgNDMuNTYgNzguNyA5MyAwIDUzLjMtNDEuODcgODIuNS05OC4xIDgyLjUtNTQuOTggMC05MC41LTI2LjItMTA3Ljg4LTYwLjU0em0tMjA5LjEzIDUuMTNjOS4zIDE2LjUgMTcuNzYgMzAuNDUgMzguMSAzMC40NSAxOS40NSAwIDMxLjcyLTcuNjEgMzEuNzItMzcuMnYtMjAxLjNoNTkuMnYyMDIuMWMwIDYxLjMtMzUuOTQgODkuMi04OC40IDg5LjItNDcuNCAwLTc0Ljg1LTI0LjUzLTg4LjgxLTU0LjA3NXoiLz4KPC9zdmc+"

/***/ }),

/***/ "./src/images/ocaml.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/images/reason_300.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reason_300.5d19cfa6.png";

/***/ }),

/***/ "./src/layouts/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	var _createClass3 = _interopRequireDefault(_createClass2);
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	var _inherits3 = _interopRequireDefault(_inherits2);
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var gatsby_link_5 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var React = __webpack_require__("./node_modules/react/index.js");
	var HeaderMenu_2 = __webpack_require__("./src/components/HeaderMenu/HeaderMenu.tsx");
	var SidebarMenu_1 = __webpack_require__("./src/components/SidebarMenu/SidebarMenu.tsx");
	var semantic_ui_react_10 = __webpack_require__("./node_modules/semantic-ui-react/dist/commonjs/index.js");
	__webpack_require__("./src/css/styles.css");
	__webpack_require__("./src/css/responsive.css");
	__webpack_require__("./src/css/semantic.min.css");
	__webpack_require__("./node_modules/prismjs/themes/prism-okaidia.css");
	exports.menuItems = [{ name: "Home", path: "/", exact: true, icon: "home", inverted: true }, { name: "Steps", path: "/steps/", exact: false, icon: "book" }, { name: "Try", path: "/try/", exact: false, icon: "code" }];
	var DefaultLayout = function (_React$PureComponent) {
	    (0, _inherits3.default)(DefaultLayout, _React$PureComponent);
	    function DefaultLayout() {
	        (0, _classCallCheck3.default)(this, DefaultLayout);
	        return (0, _possibleConstructorReturn3.default)(this, (DefaultLayout.__proto__ || Object.getPrototypeOf(DefaultLayout)).apply(this, arguments));
	    }
	    (0, _createClass3.default)(DefaultLayout, [{
	        key: "render",
	        value: function render() {
	            var pathname = this.props.location.pathname;
	            var isHome = pathname === "/" || pathname === "/gradus-reason" || pathname === "/gradus-reason/";
	            return React.createElement(semantic_ui_react_10.Sidebar.Pushable, { as: semantic_ui_react_10.Segment }, React.createElement(SidebarMenu_1.default, { Link: gatsby_link_5.default, pathname: pathname, items: exports.menuItems, visible: false }), React.createElement(semantic_ui_react_10.Sidebar.Pusher, { style: { minHeight: "100vh" } }, isHome ? null : React.createElement(HeaderMenu_2.default, { Link: gatsby_link_5.default, pathname: pathname, items: exports.menuItems }), React.createElement("div", { style: { paddingBottom: 60 } }, this.props.children()), React.createElement(semantic_ui_react_10.Segment, { inverted: true, vertical: true, style: { position: "absolute", bottom: 0, width: "100%" } }, React.createElement(semantic_ui_react_10.Container, { textAlign: "center" }, React.createElement("a", { href: "https://github.com/codekiln/gradus-reason", target: "_blank" }, React.createElement(semantic_ui_react_10.Icon, { circular: true, link: true, color: "pink", size: "big", name: "github" }))))));
	        }
	    }]);
	    return DefaultLayout;
	}(React.PureComponent);
	exports.default = DefaultLayout;

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/home/travis/build/codekiln/gradus-reason/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\"]}!./node_modules/ts-loader/index.js?{\"compilerOptions\":{\"target\":\"esnext\",\"experimentalDecorators\":true,\"jsx\":\"react\",\"module\":\"commonjs\"},\"transpileOnly\":true}!./node_modules/babel-loader/lib/index.js?{\"presets\":[\"babel-preset-env\"],\"plugins\":[\"/home/travis/build/codekiln/gradus-reason/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\"]}!./node_modules/ts-loader/index.js!./src/pages/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/index.js");
	var gatsby_link_2 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var HeaderMenu_1 = __webpack_require__("./src/components/HeaderMenu/HeaderMenu.tsx");
	var layouts_1 = __webpack_require__("./src/layouts/index.tsx");
	var semantic_ui_react_3 = __webpack_require__("./node_modules/semantic-ui-react/dist/commonjs/index.js");
	var reasonWordLogo = __webpack_require__("./src/images/reason_300.png");
	var reasonIcon = __webpack_require__("./src/images/icon_75.png");
	var ocamlLogo = __webpack_require__("./src/images/ocaml.svg");
	var jsLogo = __webpack_require__("./src/images/js_logo.svg");
	var gradus1 = __webpack_require__("./src/images/gradus_1.jpg");
	var gradus2 = __webpack_require__("./src/images/gradus_2.jpg");
	var gradus3 = __webpack_require__("./src/images/gradus_3.jpg");
	exports.default = function (props) {
	    return React.createElement("div", null, React.createElement(semantic_ui_react_3.Segment, { vertical: true, textAlign: "center", className: "masthead" }, React.createElement(HeaderMenu_1.default, { Link: gatsby_link_2.default, pathname: props.location.pathname, items: layouts_1.menuItems }), React.createElement(semantic_ui_react_3.Container, { text: true }, React.createElement(semantic_ui_react_3.Header, { as: "h1" }, "Gradus ", React.createElement("img", { src: reasonWordLogo, alt: "Reason" })), React.createElement(semantic_ui_react_3.Header, { as: "h2" }, "Steps to learning Reason OCaml"))), React.createElement(semantic_ui_react_3.Segment, { vertical: true, className: "stripe", inverted: true }, React.createElement(semantic_ui_react_3.Container, { text: true }, React.createElement(semantic_ui_react_3.Grid, { stackable: true, verticalAlign: "top", className: "container" }, React.createElement(semantic_ui_react_3.Grid.Row, { width: "8" }, React.createElement(semantic_ui_react_3.Header, { inverted: true }, React.createElement(semantic_ui_react_3.Image, { inline: true, src: reasonIcon, as: "a", href: "https://reasonml.github.io/", target: "_blank", size: "tiny", spaced: "right" }), "Why Reason?"), React.createElement("p", null, "As a strongly typed functional language, ", React.createElement("a", { target: "_blank", href: "https://reasonml.github.io/" }, "Reason"), " can decrease the number of tests needed to maintain correctness over the lifetime of the program.", React.createElement("a", { target: "_blank", href: "https://www.youtube.com/watch?v=L0xz-ILKsLE" }, "\xA0 Tests explain you what ", React.createElement("em", null, "remember"), " about your program; types tell you what you ", React.createElement("em", null, "forgot"), "."))), React.createElement(semantic_ui_react_3.Grid.Row, null, React.createElement(semantic_ui_react_3.Grid.Column, { width: "7" }, React.createElement(semantic_ui_react_3.Header, { inverted: true }, React.createElement(semantic_ui_react_3.Image, { inline: true, src: ocamlLogo, as: "a", href: "https://ocaml.org/", target: "_blank", size: "tiny", spaced: "right" }), "OCaml Rigor"), React.createElement("p", null, "Reason ", React.createElement("a", { href: "https://ocaml.org/", target: "_blank" }, "is OCaml"), ". It ", React.createElement("a", { href: "https://goo.gl/qxQCct" }, "compiles to a fast native executable"), ", and yet (unlike C or C++) is garbage collected, making it easier to write bug-free code. Using ", React.createElement("a", { href: "https://mirage.io/" }, "MirageOS"), " you can compile your program down to a minimal operating system that runs on bare metal.")), React.createElement(semantic_ui_react_3.Grid.Column, { width: "7" }, React.createElement(semantic_ui_react_3.Header, { inverted: true }, React.createElement(semantic_ui_react_3.Image, { inline: true, src: jsLogo, as: "a", href: "https://reasonml.github.io/guide/what-and-why", target: "_blank", size: "tiny", spaced: "right" }), "JavaScript Community"), React.createElement("p", null, "As language that ", React.createElement("a", { target: "_blank", href: "https://reasonml.github.io/guide/what-and-why" }, "can both use and compile to human-readable Javascript"), ", Reason lets you leverage the npm ecosystem into into higher performance, correctness and portability outside of the node runtime.")))))), React.createElement(semantic_ui_react_3.Segment, { raised: true, vertical: true, clearing: true, className: "stripe feature" }, React.createElement(semantic_ui_react_3.Container, null, React.createElement(semantic_ui_react_3.Header, { as: "h3" }, "About ", React.createElement("em", null, "Gradus Reason")), React.createElement(semantic_ui_react_3.Card.Group, { stackable: true, itemsPerRow: "3" }, React.createElement(semantic_ui_react_3.Card, null, React.createElement(semantic_ui_react_3.Card.Content, null, React.createElement(semantic_ui_react_3.Card.Header, null, "What is this site?"), React.createElement(semantic_ui_react_3.Card.Description, null, React.createElement("p", null, "This site is a collection of steps for learning and using Reason. The ", React.createElement(gatsby_link_2.default, { to: "/steps/" }, "steps"), " give practical examples that go beyond the core ", React.createElement(gatsby_link_2.default, { to: "https://reasonml.github.io/guide/" }, "Reason Guide"), "."), React.createElement(semantic_ui_react_3.Image, { centered: true, size: "medium", src: gradus1 })))), React.createElement(semantic_ui_react_3.Card, null, React.createElement(semantic_ui_react_3.Card.Content, null, React.createElement(semantic_ui_react_3.Card.Header, null, "What does ", React.createElement("em", null, "Gradus Reason"), " mean?"), React.createElement(semantic_ui_react_3.Card.Description, null, React.createElement("p", null, React.createElement("em", null, "Gradus"), " is the latin word for \"Steps.\" Many of the earliest textbooks were titled ", React.createElement("a", { href: "https://en.wikipedia.org/wiki/Gradus_ad_Parnassum" }, React.createElement("em", null, "Gradus ad Parnassum")), ", or \"steps to Parnassus,\" a mountain region in Greece. These books provided a way for scholars to ", React.createElement("em", null, "gradually"), " learn how to write Greek and Latin verse."), React.createElement(semantic_ui_react_3.Image, { centered: true, size: "small", src: gradus2 })))), React.createElement(semantic_ui_react_3.Card, null, React.createElement(semantic_ui_react_3.Card.Content, null, React.createElement(semantic_ui_react_3.Card.Header, null, "I'm learning Reason! May I contribute content?"), React.createElement(semantic_ui_react_3.Card.Description, null, React.createElement("p", null, "Please do! This project was started with the intention of helping the community document examples of how to do basic, useful things with Reason. Please submit a pull request to the ", React.createElement("a", { href: "https://github.com/codekiln/gradus-reason" }, "github repo"), "."), React.createElement(semantic_ui_react_3.Image, { centered: true, size: "small", src: gradus3 }))))))));
	};

/***/ }),

/***/ "./src/store.ts":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var redux_1 = __webpack_require__("./node_modules/redux/lib/index.js");
	var redux_devtools_extension_1 = __webpack_require__("./node_modules/redux-devtools-extension/index.js");
	// Actions
	exports.TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
	exports.toggleSidebar = function () {
	    return { type: exports.TOGGLE_SIDEBAR };
	};
	// Reducer
	exports.reducer = function (state, action) {
	    switch (action.type) {
	        case exports.TOGGLE_SIDEBAR:
	            return Object.assign({}, state, { isSidebarVisible: !state.isSidebarVisible });
	        default:
	            return state;
	    }
	};
	// Store
	exports.initialState = { isSidebarVisible: false };
	exports.store = redux_1.createStore(exports.reducer, exports.initialState, redux_devtools_extension_1.devToolsEnhancer({}));

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-tsx-5e5232cca31050d77236.js